var _g, _g2, _g3;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLocationPin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 18V17C16 15.8954 16.8954 15 18 15C19.1046 15 20 15.8954 20 17V18M16.9527 11C16.9839 10.7366 17 10.47 17 10.2C17 6.22355 13.866 3 10 3C6.13401 3 3 6.22355 3 10.2C3 14.1764 6.5 17.4 10 21C10.3344 20.6561 10.6687 20.3156 11 19.9776M16.5 21H19.5C19.9659 21 20.1989 21 20.3827 20.9239C20.6277 20.8224 20.8224 20.6277 20.9239 20.3827C21 20.1989 21 19.9659 21 19.5C21 19.0341 21 18.8011 20.9239 18.6173C20.8224 18.3723 20.6277 18.1776 20.3827 18.0761C20.1989 18 19.9659 18 19.5 18H16.5C16.0341 18 15.8011 18 15.6173 18.0761C15.3723 18.1776 15.1776 18.3723 15.0761 18.6173C15 18.8011 15 19.0341 15 19.5C15 19.9659 15 20.1989 15.0761 20.3827C15.1776 20.6277 15.3723 20.8224 15.6173 20.9239C15.8011 21 16.0341 21 16.5 21ZM13 10C13 11.6569 11.6569 13 10 13C8.34315 13 7 11.6569 7 10C7 8.34315 8.34315 7 10 7C11.6569 7 13 8.34315 13 10Z",
    stroke: "#4299E1",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationPin);
export default __webpack_public_path__ + "static/media/location-pin.0a044f7697f25efa84b0f9318fbe142b.svg";
export { ForwardRef as ReactComponent };